import React from "react";
import EditProfileMain from "../../../components/auth/edit-profile/EditProfileMain";
import Sidebar from "../../../components/common/Sidebar";
import { RODEO_PAGE_NAME } from "../../../_config";
import requireAuth from "../../../_common/hoc/reqAuth";

const EditProfilePage: React.FC = () => {
  return (
    <>
      <Sidebar page={RODEO_PAGE_NAME.EDIT_PROFILE} />
      <EditProfileMain />
    </>
  );
};

export default requireAuth(EditProfilePage);